<template>
  <b-row class="justify-content-center">
    <b-col md="6" xl="6">
      <b-card>
        <div class="card-title">
          <h4 class="d-inline-block">Detail Pengajuan Pinjaman</h4>
          <b-badge
            :variant="statusVariant(data.status)"
            class="ml-1 font-small-2 float-right"
          >
            {{ statusName(data.status) }}
          </b-badge>
        </div>
        <b-overlay :show="loading" rounded="sm">
          <b-form-group label="Nama Lengkap" label-for="name">
            <b-form-input id="name" type="text" v-model="data.name" readonly />
          </b-form-group>
          <b-form-group label="No Hp" label-for="phone">
            <b-form-input
              id="phone"
              maxlength="13"
              type="number"
              v-model="data.phone"
              readonly
            />
          </b-form-group>
          <b-form-group label="Email" label-for="email">
            <b-form-input
              id="email"
              type="text"
              v-model="data.email"
              readonly
            />
          </b-form-group>
          <b-form-group label="Jumlah Pinjaman" label-for="loan-amount">
            <b-form-input
              id="loan-amount"
              type="text"
              v-model="data.loan_amount_formatted"
              readonly
            />
          </b-form-group>
          <b-form-group label="Tenor" label-for="period">
            <b-form-input
              id="period"
              type="text"
              v-model="data.period_name"
              readonly
            />
          </b-form-group>
          <b-form-group label="Jaminan" label-for="collateral">
            <b-form-input
              id="collateral"
              type="text"
              v-model="data.collateral_name"
              readonly
            />
          </b-form-group>
          <b-form-group label="Tanggal Pengajuan" label-for="date">
            <b-form-input id="date" v-model="data.date" readonly />
          </b-form-group>
          <b-form-group
            label="Bukti Foto"
            label-for="image"
            class="input-image"
          >
            <div class="d-block text-center">
              <b-img
                thumbnail
                fluid
                :src="media"
                v-b-modal.modal-image
                @click="showImage(data.image)"
                style="height: 500px"
              />
            </div>
          </b-form-group>
          <b-modal id="modal-image" centered title="" ok-only size="lg">
            <div class="text-center">
              <b-img :src="media" class="img-fluid" />
            </div>
          </b-modal>
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { $themeConfig } from "@themeConfig";
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BFormFile,
  BOverlay,
  BImg,
  BBadge,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import ImageUploader from "vue-image-upload-resize";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BFormFile,
    flatPickr,
    ImageUploader,
    BOverlay,
    BImg,
    BBadge,
  },
  setup() {
    const { baseUrl } = $themeConfig.app;
    return {
      baseUrl,
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        0: "light-secondary",
        1: "light-primary",
        2: "light-success",
        3: "light-warning",
      };

      return (status) => statusColor[status];
    },
    statusName() {
      const statusName = {
        0: "Pending",
        1: "On Process",
        2: "Approved",
        3: "Rejected",
      };

      return (status) => statusName[status];
    },
  },
  data() {
    return {
      loading: false,
      hasImage: false,
      media: null,
      datepicker: {
        dateFormat: "d-m-Y",
      },
      data: {
        name: null,
        phone: null,
        proven_at: null,
        image: null,
        note: null,
        account_no: null,
      },
      loanId: null,
    };
  },
  created() {
    this.loanId = this.$store.state.app.loanId;

    if (this.$store.state.app.loanId === null) {
      this.loanId = localStorage.getItem("loanId", this.loanId);
    }
    this.getData();
  },
  methods: {
    getData() {
      this.$http.get("/adira/loan/" + this.loanId).then((res) => {
        var $data = res.data.data;
        this.data = $data;
        this.media = this.baseUrl + "image/adira/loan/" + $data.image;
      });
    },
    showImage($filename) {
      this.media = this.baseUrl + "image/adira/loan/" + $filename;
    },
    makeToast(variant = null) {
      this.$bvToast.toast("Toast body content", {
        title: `Variant ${variant || "default"}`,
        variant,
        solid: true,
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
